import React from 'react';
import { Link } from 'react-router-dom';

// Import images
import downloadImage from '../assets/img/download/02.jpg';

const DownloadArea = () => {
  return (
    <div>
      <style jsx>{`
        .site-title-tagline {
          color: #098535 !important;
        }
        
        .site-title span {
          color: #098535 !important;
        }
        
        .download-btn a, .download-btn-link {
          background-color: #000000 !important;
          border: none !important;
          color: white !important;
          text-decoration: none;
          display: flex;
          align-items: center;
          padding: 15px 25px;
          border-radius: 10px;
          margin: 10px 0;
          transition: all 0.3s ease;
          width: 100%;
          max-width: 320px;
          box-sizing: border-box;
        }
        
        .download-btn a:hover, .download-btn-link:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        }
        
        .download-btn {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          margin-top: 20px;
          width: 100%;
        }
        
        .download-btn-content {
          margin-left: 15px;
          flex: 1;
        }
        
        .download-btn-content span {
          display: block;
          font-size: 14px;
          opacity: 0.8;
        }
        
        .download-btn-content strong {
          display: block;
          font-size: 18px;
          font-weight: bold;
        }
        
        .fab {
          font-size: 40px;
          min-width: 40px;
        }
        
        .fab.fa-google-play {
          color: #34a853;
        }
        
        .fab.fa-app-store {
          color: #ffffff;
        }
        
        .fab.fa-android {
          color: #a4c639;
        }
        
        /* Full width content for writeup */
        .download-content {
          width: 100%;
          margin-bottom: 40px;
        }
        
        /* Desktop: buttons and image side by side */
        .download-wrapper {
          display: flex;
          flex-direction: column;
        }
        
        .button-image-row {
          display: flex;
          align-items: center;
          gap: 40px;
          margin-top: 30px;
        }
        
        .buttons-col {
          flex: 1;
        }
        
        .image-col {
          flex: 1;
          text-align: center;
        }
        
        .image-col img {
          max-width: 100%;
          height: auto;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        /* Mobile Styles */
        @media (max-width: 992px) {
          .button-image-row {
            flex-direction: column;
            gap: 30px;
          }
          
          .download-btn {
            flex-direction: column;
            align-items: center;
            gap: 20px;
          }
          
          .download-btn a, .download-btn-link {
            width: 100%;
            max-width: 100%;
            margin: 0;
            justify-content: flex-start;
          }
          
          .download-btn-content {
            margin-left: 20px;
          }
          
          .fab {
            font-size: 36px;
            min-width: 36px;
          }
          
          .image-col img {
            max-width: 80%;
          }
        }
        
        /* Small mobile devices */
        @media (max-width: 576px) {
          .download-btn a, .download-btn-link {
            padding: 12px 20px;
          }
          
          .download-btn-content span {
            font-size: 13px;
          }
          
          .download-btn-content strong {
            font-size: 16px;
          }
          
          .fab {
            font-size: 32px;
            min-width: 32px;
          }
          
          .image-col img {
            max-width: 100%;
          }
        }
      `}</style>
      
      <div className="download-area pt-120">
        <div className="container">
          <div className="download-wrapper">
            {/* Full width writeup section */}
            <div className="download-content">
              <div className="site-heading mb-4">
                <span className="site-title-tagline justify-content-start">
                  <i className="flaticon-drive"></i> Get Our App
                </span>
                <h2 className="site-title mb-10">
                  Your Journey, <span>Our Priority</span> – Download CabandGo
                </h2>
                <div style={{ fontSize: '16px', lineHeight: '1.7', marginBottom: '20px' }}>
                  <p>
                    Experience seamless mobility at your fingertips. Whether you need a quick ride across town, 
                    reliable delivery services, or efficient transportation for your packages, CabandGo connects 
                    you to trusted drivers and delivery partners in real-time.
                  </p>
                  <p>
                    <strong>Why choose our app?</strong> Enjoy exclusive features like fare estimates, real-time tracking, 
                    secure payments, driver ratings, and priority booking. Transform how you move through cities 
                    and connect with communities.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Buttons and image side by side on desktop */}
            <div className="button-image-row">
              <div className="buttons-col">
                <div className="download-btn">
                  <a href="#">
                    <i className="fab fa-google-play"></i>
                    <div className="download-btn-content">
                      <span>Available on</span>
                      <strong>Google Play</strong>
                    </div>
                  </a>
                  <a href="#">
                    <i className="fab fa-app-store"></i>
                    <div className="download-btn-content">
                      <span>Download on</span>
                      <strong>App Store</strong>
                    </div>
                  </a>
                  <Link to="/android-download" className="download-btn-link">
                    <i className="fab fa-android"></i>
                    <div className="download-btn-content">
                      <span>Direct Download</span>
                      <strong>Android APK</strong>
                    </div>
                  </Link>
                </div>
              </div>
              
              <div className="image-col">
                <img src={downloadImage} alt="Download CabandGo app for seamless transportation" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DownloadArea